import { render, staticRenderFns } from "./TableAction.vue?vue&type=template&id=a23bc6d8&scoped=true"
import script from "./TableAction.vue?vue&type=script&lang=ts"
export * from "./TableAction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23bc6d8",
  null
  
)

export default component.exports